import { useEffect, useState } from 'react';
import type { FieldValues, FormState } from 'react-hook-form';

import { isDeepEqual } from '../utils/deep-compare';

/*
The code below will check if 'formState' values has changed compared to the one that is current being stored in state.
If the current new formState do not match with the stored formState, the 'setOurFormState' would be called to update
the state with the latest data.

Clone formState, cannot use `...` or `Object.assign` as formState is a Proxy object with no enumerable properties
*/
export function useMemoizedFormState(formState: FormState<FieldValues>) {
    const [ourFormState, setOurFormState] = useState({
        isDirty: formState.isDirty,
        dirtyFields: formState.dirtyFields,
        isSubmitted: formState.isSubmitted,
        isSubmitSuccessful: formState.isSubmitSuccessful,
        submitCount: formState.submitCount,
        touchedFields: formState.touchedFields,
        isSubmitting: formState.isSubmitting,
        isValidating: formState.isValidating,
        isValid: formState.isValid,
        isLoading: formState.isLoading,
        errors: formState.errors,
    });

    useEffect(() => {
        const newFormState = {
            isDirty: formState.isDirty,
            dirtyFields: formState.dirtyFields,
            isSubmitted: formState.isSubmitted,
            isSubmitSuccessful: formState.isSubmitSuccessful,
            submitCount: formState.submitCount,
            touchedFields: formState.touchedFields,
            isSubmitting: formState.isSubmitting,
            isValidating: formState.isValidating,
            isValid: formState.isValid,
            isLoading: formState.isLoading,
            errors: formState.errors,
        };

        if (!isDeepEqual(newFormState, ourFormState)) {
            setOurFormState(newFormState);
        }
    }, [formState, ourFormState, setOurFormState]);

    return [ourFormState];
}
